var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReturnpolicy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 32,
    viewBox: "0 0 43 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4024 31.5805C17.1514 31.5805 13.4989 30.0568 10.4449 27.0095C7.39128 23.9622 5.86445 20.3193 5.86445 16.081V13.119L1.59495 17.4075L0.106445 15.919L6.99895 9.00749L13.9104 15.919L12.4219 17.4075L8.13345 13.119V16.081C8.13345 19.7243 9.43095 22.8403 12.0259 25.429C14.6206 28.0173 17.7461 29.3115 21.4024 29.3115C22.3051 29.3115 23.1834 29.2313 24.0374 29.071C24.8911 28.911 25.6949 28.6772 26.4489 28.3695L28.0794 30C26.9948 30.5513 25.8986 30.9527 24.7909 31.204C23.6833 31.455 22.5538 31.5805 21.4024 31.5805ZM35.6989 23.054L28.7874 16.1425L30.3259 14.623L34.5644 18.881V16.081C34.5644 12.4373 33.2669 9.32116 30.6719 6.7325C28.0769 4.14416 24.9578 2.84999 21.3144 2.84999C20.3988 2.84999 19.5173 2.93199 18.6699 3.09599C17.8226 3.26033 17.0156 3.47583 16.2489 3.74249L14.6374 2.11149C15.7091 1.56016 16.8019 1.16716 17.9159 0.932495C19.0303 0.698162 20.1631 0.580994 21.3144 0.580994C25.5654 0.580994 29.2148 2.10149 32.2624 5.14249C35.3098 8.18349 36.8334 11.8297 36.8334 16.081V18.9425L41.1219 14.673L42.6104 16.1425L35.6989 23.054Z",
    fill: "#F88D2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnpolicy);
export default __webpack_public_path__ + "static/media/returnpolicy.041257790eaaa4c45caffd84bae4815c.svg";
export { ForwardRef as ReactComponent };